import { XHRBackend, Http, RequestOptions, Headers } from "@angular/http";
import { CustomHttp } from "app/customhttp";
import { AuthenticationService } from "app/service/authentication.service";
import { Router } from "@angular/router";

export function CustomHttpFactory(router: Router, xhrBackend: XHRBackend, requestOptions: RequestOptions): Http {
    return new CustomHttp(router, xhrBackend, requestOptions);
}


// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/customhttp.factory.ts